import { getCookies } from './getCookies';
import { SHA256 } from '../../helpers';

const isEmpty = (value) => [undefined, null].includes(value) || `${value}`.trim() === '';

const hash = (value) => (isEmpty(value) ? undefined : SHA256(`${value}`));

export const parseUserData = ({ country, emailSHA256, firstName, lastName, phone, ...others } = {}) => ({
  firstName: hash(firstName),
  lastName: hash(lastName),
  country: isEmpty(country) ? undefined : country,
  email: isEmpty(emailSHA256) ? undefined : emailSHA256,
  phone: hash(phone),
  ...getCookies(),
  ...others,
});
